// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import RegistrationStatus from '../state/registration-status';
import RegistrationsReviewDates from './registrations-review-dates';
import RegistrationsReviewDealerCriteria from './registrations-review-dealer-criteria';
import RegistrationsReviewStatusCriteria from './registrations-review-status-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const RegistrationsReviewCriteria = props =>
    <div className='registrations-review-criteria'>
        <div className='criteria-container'>
            <RegistrationsReviewDealerCriteria
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedAccounts={props.selectedAccounts}
                selectedDealers={props.selectedDealers}
            />
            <RegistrationsReviewStatusCriteria
                onSelectAllStatuses={props.onSelectAllStatuses}
                onStatusSelect={props.onStatusSelect}
                registrationStatus={props.registrationStatus}
            />
            <div className='date-criteria'>
                <RegistrationsReviewDates
                    dateRange={props.registrationDate}
                    label='REGISTERED'
                    onDateChange={props.onRegistrationDateChange}
                />
                <RegistrationsReviewDates
                    dateRange={props.deliveryDate}
                    label='DELIVERED'
                    onDateChange={props.onDeliveryDateChange}
                />
            </div>
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

RegistrationsReviewCriteria.displayName = 'RegistrationsReviewCriteria';
RegistrationsReviewCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    deliveryDate: PropTypes.instanceOf(DateRange).isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onDeliveryDateChange: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onRegistrationDateChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    onSelectAllStatuses: PropTypes.func.isRequired,
    onStatusSelect: PropTypes.func.isRequired,
    registrationDate: PropTypes.instanceOf(DateRange).isRequired,
    registrationStatus: PropTypes.instanceOf(RegistrationStatus).isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default RegistrationsReviewCriteria;



// WEBPACK FOOTER //
// ./src/reports/registrations-review/components/registrations-review-criteria.js